<template>
 <div class="page-wrapper" >
    <div class="container" v-if="booking_found">

      <div class="logo-row">
      <img src="@/assets/images/logo/NudgPay.png" alt="Nudg Logo" class="logo" />

      </div>
      <div class="content-row">
        <div class="left-column">
        <h1>Download The APP <span class="highlight">24/7</span></h1>
        <p class="note">
          Your Taxi, Booked, Dispatched & Delivered upon request at any time. We
          work round the clock to ensure you get to your destination as quick as
          possible.
        </p>
        <div v-if="!is_archived && payment_done_case" class="receipt-box">
          <input type="email" placeholder="Recipient's Email"  name="email" v-model="email" class="input-email">
          <button class="pay-now" @click="getReciept">Payment Receipt</button>
        </div>
      </div>
        <div class="right-column">
          <div class="card">
            <h3>Journey Details</h3>
            <p v-if="!(bookingData.is_archived) && isSuccess=='success' && payment_done"  class="driver-note mt-4 ">PLEASE SHOW THIS TO YOUR DRIVER</p>
            <div class="details">
              <div class="row">
                <span class="label">Booking ID</span>
                <span class="booking-value">{{ decryptedBookingId }}</span>
              </div>
              <div class="row">
                <span class="label">Pick Up</span>
                <span class="value">{{  bookingData.pickup }}</span>
              </div>
              <div class="row">
                <span class="label">Drop Off</span>
                <span class="value" >{{  bookingData.destination }}</span>
              </div>
              <div class="row">
                <span class="label">Pick Up Due Time</span>
                <span class="booking-value">{{ bookingPickupTime }}</span>
              </div>
              <div v-if="!(bookingData.is_archived) && isSuccess=='success' && payment_done"  class="row">
                <span class="label">AuthCode</span>
                <span class="booking-value">{{ authcode }}</span>
              </div>
              <div v-if="!(bookingData.is_archived) && isSuccess=='success' && payment_done">
                <div class="row" v-if="bookingData.booking_status == 'booked'||bookingData.booking_status == 'active'">
                  <span class="booking-value">PAID BEFORE JOURNEY</span>
                </div>
                <div v-else class="row">
                  <span class="label">Driver Callsign</span>
                  <span class="booking-value">{{ driverCallsign }}</span>
                </div>
              </div>

            </div>
            <div  v-if="!(bookingData.is_archived) && isSuccess=='success' && payment_done"   class="payment-status-note">
              Your payment was successful. The driver will be informed!
              <div class="buttons">
                <button class="pay-now" @click="redirectReload"> Back to Link </button>
              </div>
            </div>

            <div v-if="isSuccess=='failure'" class="error">
              <span>Your payment was declined or cancelled </span>
              <div v-if="!payment_done && isCardPayment" class="buttons">
                <button class="pay-now"  @click="payCash"> Pay by Cash </button>
                <button class="pay-now" @click="redirectReload"> Retry Card </button>
              </div>
              <div v-else class="buttons">
                <button class="pay-now" @click="redirectReload"> Back to Link </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
 </div>
</template>
<script>
import { _getBooking, _asCashPayment, _getReceipt } from "@/services/Payment";
import { MAIN_DOMAIN } from "@/environment/index";

export default {
  beforeMount() {
    document.documentElement.style.overflow = "hidden";
    this.$vs.loading({ text: "Fetching data......" });
     const favicon = document.getElementById("favicon");
    if (favicon) {
      favicon.href = require("@/assets/images/logo/NudgPay.png");
    }

    _getBooking(this.bookingId).then((res) => {
      this.companyLogo = res.data.obj.company_logo? MAIN_DOMAIN+res.data.obj.company_logo:null
      this.bookingData = res.data.obj;
      this.payment_done = res.data.obj.checkezp;
      this.amount = res.data.obj.price;
      this.amount_type =
        res.data.obj.is_fixed_price == true ? "Fixed" : "Variable";
      this.booking_found = true;
      this.authcode = res.data.obj.authcode,
      this.decryptedBookingId = res.data.obj.decrypt_booking_id,
      this.bookingPickupTime = res.data.obj.booking_pickup_due_time,
      this.driverCallsign = res.data.obj.driver_callsign
      this.status = res.data.obj.booking_status
      this.isCardPayment = this.bookingData.payment_type == 'CARD'|| this.bookingData.payment_type == 'Card'
       document.title = "Redirect";
      this. $vs.loading.close();
    });
  },

  data() {
    return {
      isSuccess: this.$route.params.response,
      bookingId: this.$route.params.booking,
      payment_done: null,
      amount_type: "",
      bookingData: {},
      amount: "",
      booking_found: false,
      email: "",
      authcode: null,
      decryptedBookingId: null,
      bookingPickupTime: null,
      driverCallsign: null,
      status: null,
      companyLogo: null,
      isCardPayment: false,

    };
  },
  methods: {
    redirectReload() {
        this.$router.push({ name: 'SmsPayment', params: { bid: this.bookingId }}).then(() => { this.$router.go(0) })
    },
    payCash() {
      _asCashPayment({ bid: this.bookingId }).then((res) => {
        console.log(
          "********************cash payment*************************"
        );

        console.log(res);
        this.bookingData.payment_type == 'Cash'
      });
    },
    getReciept() {
      if (!this.email) alert("Please enter valid email to get receipt");
      _getReceipt({ email: this.email }, this.bookingData.payment).then(
        (res) => {
          alert('email has been sent to your given address');
          this.email ='';
        }
      );
    },
  },
};
</script>

<style scoped>
@import "./promot.css";




</style>


